import { Button as Btn } from '@mui/material'
import { darken, lighten } from 'polished'
import { BiError } from 'react-icons/bi'
import { BsFillInfoCircleFill } from 'react-icons/bs'
import { IoShieldCheckmark } from 'react-icons/io5'
import { RiErrorWarningFill } from 'react-icons/ri'
import styled, { css } from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

const darkenValue = 0.05
const darkenFn = darken(darkenValue)
const lightenFn = lighten(0.4)

const COLORS = {
  error: 'danger',
  warning: 'warning',
  info: 'info',
  success: 'success',
}

type VariantProps = {
  variant: 'card' | 'page'
  warningPayment?: boolean
}
type ContainerProps = VariantProps & {
  severity: string
  warningPayment?: boolean
  dense?: boolean
}

export const Container = styled.div<ContainerProps>`
  border-radius: 2px;
  display: flex;
  gap: 10px;
  margin-block: 10px;
  flex-direction: column !important;
  justify-content: flex-start;
  padding: ${({ dense }) => (dense ? '15px 15px' : '18px 15px')} !important;
  width: 100%;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    flex-direction: row;
  }

  ${({ severity, variant, theme, warningPayment }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          border-left: 2px solid ${darkenFn(theme.colors?.[COLORS[severity]])} !important;
          background-color: ${lightenFn(theme.colors?.[COLORS[severity]])} !important;
        `
      : /* VARIANTE PAGE */ css`
          background-color: ${warningPayment
            ? theme?.colors?.warningPayment
            : darkenFn(theme.colors?.[COLORS[severity]])} !important;
          color: ${theme?.colors?.white} !important;
        `};
`

export const Content = styled.div<{ dense: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: ${({ dense }) => (dense ? '40px' : '50px')} !important;
`

export const Title = styled.h1<VariantProps>`
  text-align: left !important;
  font: normal normal bold 13px/20px Manrope, sans-serif !important;
  margin: 0px !important;
  ${({ variant, theme, warningPayment }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          color: ${theme?.colors?.text} !important;
        `
      : /* VARIANTE PAGE */ css`
          color: ${warningPayment ? theme?.colors?.black : theme?.colors?.white} !important;
        `};
`

export const Description = styled.p<VariantProps>`
  text-align: left !important;
  font: normal normal normal 13px/20px Manrope, sans-serif !important;
  margin: 0px !important;
  ${({ theme, variant, warningPayment }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          color: ${theme?.colors?.gray6} !important;
        `
      : /* VARIANTE PAGE */ css`
          color: ${warningPayment ? theme?.colors?.black : theme?.colors?.white} !important;
        `};
`

export const ButtonContainer = styled.div`
  @media (min-width: calc(${BREAKPOINT_SM})) {
    margin-left: auto;
  }
`

export const Icon = css`
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  font-size: 24px;
  position: absolute;
`

export const ErrorIcon = styled(BiError)<ContainerProps>`
  ${Icon};
  margin-left: ${({ dense }) => (dense ? '-40px' : '-50px')} !important;
  ${({ variant, theme, severity }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          color: ${darkenFn(theme.colors?.[COLORS[severity]])} !important;
        `
      : /* VARIANTE PAGE */ css`
          color: ${theme?.colors?.white} !important;
        `};
`

export const WarningIcon = styled(RiErrorWarningFill)<ContainerProps>`
  ${Icon};
  margin-left: ${({ dense }) => (dense ? '-40px' : '-50px')} !important;
  ${({ variant, theme, severity, warningPayment }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          color: ${darkenFn(theme.colors?.[COLORS[severity]])} !important;
        `
      : /* VARIANTE PAGE */ css`
          color: ${warningPayment ? theme?.colors?.black : theme?.colors?.white} !important;
        `};
`

export const InfoIcon = styled(BsFillInfoCircleFill)<ContainerProps>`
  ${Icon};
  margin-left: ${({ dense }) => (dense ? '-40px' : '-50px')} !important;
  ${({ variant, theme, severity }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          color: ${darkenFn(theme.colors?.[COLORS[severity]])} !important;
        `
      : /* VARIANTE PAGE */ css`
          color: ${theme?.colors?.white} !important;
        `};
`

export const SuccessIcon = styled(IoShieldCheckmark)<ContainerProps>`
  ${Icon};
  margin-left: ${({ dense }) => (dense ? '-40px' : '-50px')} !important;
  ${({ variant, theme, severity }) =>
    variant === 'card'
      ? /* VARIANTE CARD */ css`
          color: ${darkenFn(theme.colors?.[COLORS[severity]])} !important;
        `
      : /* VARIANTE PAGE */ css`
          color: ${theme?.colors?.white} !important;
        `};
`

export const Button = styled(Btn)`
  color: ${({ theme }) => theme.colors?.gray3} !important;
  border-color: ${({ theme }) => theme.colors?.gray3} !important;
`

export const IconSearch = styled.img`
  margin-right: 4px;
`
